import { type PropsWithChildren, type JSX } from 'react';
import { useIsHotpotEnabled } from './useIsHotpotEnabled';
import { getFrontendConfigLoader } from '@doxyme/config';
import { HotpotProvider } from '@doxyme/hotpot/react';
import { hotpotLogger } from './hotpot.logger';

/**
 * A wrapper for the Hotpot provider that enables it based on the GrowthBook config.
 * Also checks if the hotpot url is set.
 */
export function HotpotProviderWrapper({
  children,
}: PropsWithChildren): JSX.Element {
  const isHotpotEnabled = useIsHotpotEnabled();
  const hotpotUrl = getFrontendConfigLoader().get('HOTPOT_URL') as
    | string
    | undefined;

  return isHotpotEnabled && !!hotpotUrl ? (
    <HotpotProvider hotpotUrl={hotpotUrl} logger={hotpotLogger}>
      {children}
    </HotpotProvider>
  ) : (
    <>{children}</>
  );
}
